import React from 'react';
import { HTTPSTATUS, LOG_TYPE } from '../commonUtil/constants';
import ErrorPage from './errorPage';
import { reportClientLog } from '../service/ViewerService';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    componentDidCatch(error, info) {
        this.setState({ hasError: true, error });

        const extraInfo = {
            userAgent: window.navigator.userAgent,
            errorCode: error && error.errorCode,
            errorMessage: error && error.message,
            errorInfo: JSON.stringify(info)
        };
        const logInfo = {
            LogType: LOG_TYPE.ERROR,
            Message: 'Viewer has unexpected error!',
            Detail: error && error.stack && error.stack.toString(),
            ExtraInfo: extraInfo
        };
        reportClientLog(logInfo, true);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="seismic-engagement-viewer-error-container" >
                    <ErrorPage errorCode={(this.state.error && this.state.error.errorCode) || HTTPSTATUS.INTERNAL_SERVER_ERROR} />
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
